import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { RouteKeys } from './route-keys';
import ListView from './ListView';
import EditView from './EditView';

const CustomPlanRouter: React.FunctionComponent = () => {
  return (
    <Switch>
      <Route path={RouteKeys.Edit} component={EditView} />
      <Route path={RouteKeys.List} component={ListView} />
    </Switch>
  );
};

export default CustomPlanRouter;
